import { FC } from 'react';

import { useSetRecoilState } from 'recoil';

import { ShopOrderForWorker } from '@shared/api/shopOrder/shopOrder.interface';
import { Button } from '@shared/components/Button';
import { simpleOpenAtomFamily } from '@shared/state/atom';
import { useId } from 'react-id-generator';

import { AgencyWorkerAccountDetailModal } from './AgencyWorkerAccountDetailModal';

interface Props {
  shopOrderList: ShopOrderForWorker[];
}

export const AgencyWorkerAccountDetailModalButton: FC<Props> =
  function AgencyWorkerAccountDetailModalButton({ shopOrderList }: Props) {
    const [id] = useId(1, 'agencyWorkerDetailModalButton');

    const openId = `${id}`;

    const setOpen = useSetRecoilState(simpleOpenAtomFamily(openId));
    return (
      <div>
        <Button
          onClick={() => {
            setOpen(true);
          }}
        >
          상세
        </Button>
        <AgencyWorkerAccountDetailModal
          openId={openId}
          shopOrderList={shopOrderList}
        ></AgencyWorkerAccountDetailModal>
      </div>
    );
  };
